import type { User } from '../../../@types/User';
import { FonctionTypeUserEnum } from '../../../utils/userFunctionsMap';
import type { SmartAttributionTarget } from './types';

export const renderUserLabel = (user: User) => `${user.firstname} ${user.lastname ? user.lastname.toUpperCase() : ''}`;

export const buildEvenDistribution = (users: User[]): SmartAttributionTarget[] => {
  if (users.length === 0) {
    return [];
  }

  const base = Math.floor(100 / users.length);
  let remainder = 100 - (base * users.length);

  return users.map((user) => {
    const extra = remainder > 0 ? 1 : 0;
    if (remainder > 0) {
      remainder -= 1;
    }
    return { user, percentage: base + extra, anchor: null };
  });
};

export const filterTransactionnaires = (users: User[]) => {
  const matches = users.filter((user) =>
    user.fonctions?.some((fonction) => fonction.type === FonctionTypeUserEnum.TRANSACTIONNAIRE),
  );
  return matches.length > 0 ? matches : users;
};

export const sumPercentages = (targets: SmartAttributionTarget[]) => targets.reduce((acc, item) => acc + item.percentage, 0);

